<template>
  <div>
    <!--西南联交所，开始-->
    <div v-if="orgid=='ins_045'">
      <div class="g-foot jigou-1-foot" style="height: 221px;">
        <img style="height: 221px;" src="../../assets/jigou-1-bottom.png">
      </div>
    </div>
    <!--西南联交所，结束-->
    <!--西藏产权，开始-->
    <div v-else-if="orgid=='ins_099'">
      <div class="g-foot jigou-1-foot" style="height: 254px;">
        <img style="height: 254px;" src="../../assets/jigou-2-bottom.png">
      </div>
    </div>
    <!--西藏产权，结束-->
    <!--河北产权，开始-->
    <div v-else-if="orgid=='ins_062'">
      <div class="g-foot jigou-1-foot" style="height: 296px;">
        <img style="height: 296px;" src="../../assets/jigou-3-bottom.png">
      </div>
    </div>
    <!--河北产权，结束-->
    <!--重庆，开始-->
    <div v-else-if="orgid=='ins_043'">
      <div class="g-foot jigou-1-foot" style="height: 226px;">
        <img style="height: 226px;" src="../../assets/jigou/jigou-4-bottom.png">
      </div>
    </div>
    <!--重庆，结束-->
    <!--安徽省产权交易中心，开始-->
    <div v-else-if="orgid=='ins_039'">
      <div class="g-foot jigou-1-foot" style="height: 90px;">
        <img style="height: 90px;" src="../../assets/jigou/jigou-anhui-bottom.png">
      </div>
    </div>
    <!--安徽省产权交易中心，结束-->
    <!--大连，开始-->
    <div v-else-if="orgid=='ins_038'">
      <div class="g-foot jigou-1-foot" style="height: 120px;">
        <img style="height: 120px;" src="../../assets/jigou/jigou-dalian-bottom.png">
      </div>
    </div>
    <!--大连，结束-->
    <!--甘肃，开始-->
    <div v-else-if="orgid=='ins_008'">
      <div class="g-foot jigou-1-foot" style="height: 203px;">
        <img style="height: 203px;" src="../../assets/jigou/jigou-gansu-bottom.png">
      </div>
    </div>
    <!--甘肃，结束-->
    <!--深圳，开始-->
    <div v-else-if="orgid=='ins_031'">
      <div class="g-foot jigou-1-foot" style="height: 135px;">
        <img style="height: 135px;" src="../../assets/jigou/jigou-shenzhen-bottom.png">
      </div>
    </div>
    <!--深圳，结束-->
    <!--北部湾，开始-->
    <div v-else-if="orgid=='ins_005'">
      <div class="g-foot jigou-1-foot" style="height: 77px;">
        <img style="height: 77px;" src="../../assets/jigou/jigou-beibuwan-bottom.png">
      </div>
    </div>
    <!--北部湾，结束-->
    <!--河南省，开始-->
    <div v-else-if="orgid=='ins_049'">
      <div class="g-foot jigou-1-foot" style="height: 172px;">
        <img style="height: 172px;" src="../../assets/jigou/jigou-henansheng-bottom.png">
      </div>
    </div>
    <!--河南省，结束-->
    <!--河南中原，开始-->
    <div v-else-if="orgid=='ins_037'">
      <div class="g-foot jigou-1-foot" style="height: 105px;">
        <img style="height: 105px;" src="../../assets/jigou/jigou-henanzhongyuan-bottom.png">
      </div>
    </div>
    <!--河南中原，结束-->
    <!--黑龙江联合产权，开始-->
    <div v-else-if="orgid=='ins_012'">
      <div class="g-foot jigou-1-foot" style="height: 297px;">
        <img style="height: 297px;" src="../../assets/jigou/jigou-heilongjiang-bottom.png">
      </div>
    </div>
    <!--黑龙江联合产权，结束-->
    <!--武汉光谷，开始-->
    <div v-else-if="orgid=='ins_066'">
      <div class="g-foot jigou-1-foot" style="height: 211px;">
        <img style="height: 211px;" src="../../assets/jigou/jigou-wuhanguanggu-bottom.png">
      </div>
    </div>
    <!--武汉光谷，结束-->
    <!--青岛，开始-->
    <div v-else-if="orgid=='ins_040'">
      <div class="g-foot jigou-1-foot" style="height: 249px;">
        <img style="height: 249px;" src="../../assets/jigou/jigou-qingdao-bottom.png">
      </div>
    </div>
    <!--青岛，结束-->
    <!--青海，开始-->
    <div v-else-if="orgid=='ins_006'">
      <div class="g-foot jigou-1-foot" style="height: 203px;">
        <img style="height: 203px;" src="../../assets/jigou/jigou-qinghai-bottom.png">
      </div>
    </div>
    <!--青海，结束-->
    <!--西部，开始-->
    <div v-else-if="orgid=='ins_028'">
      <div class="g-foot jigou-1-foot" style="height: 140px;">
        <img style="height: 140px;" src="../../assets/jigou/jigou-xibu-bottom.png">
      </div>
    </div>
    <!--西部，结束-->
    <!--新疆产权交易所，开始-->
    <div v-else-if="orgid=='ins_014'">
      <div class="g-foot jigou-1-foot" style="height: 242px;">
        <img style="height: 242px;" src="../../assets/jigou/jigou-xinjiang-bottom.png">
      </div>
    </div>
    <!--新疆产权交易所，结束-->
    <!--山东，开始-->
    <div v-else-if="orgid=='ins_033'">
      <div class="g-foot jigou-1-foot" style="height: 228px;">
        <img style="height: 228px;" src="../../assets/jigou/jigou-shandong-bottom.png">
      </div>
    </div>
    <!--山东，结束-->
    <!--云南，开始-->
    <div v-else-if="orgid=='ins_015'">
      <div class="g-foot jigou-1-foot" style="height: 164px;">
        <img style="height: 164px;" src="../../assets/jigou/jigou-yunnan-bottom.png">
      </div>
    </div>
    <!--云南，结束-->

    <!--江苏，开始-->
    <div v-else-if="orgid=='ins_010'">
      <div class="g-foot jigou-1-foot" style="height: 176px;">
        <img style="height: 176px;" src="../../assets/jigou/jigou-jiangsu-bottom.png">
      </div>
    </div>
    <!--江苏，结束-->
    <!--江西，开始-->
    <div v-else-if="orgid=='ins_016'">
      <div class="g-foot jigou-1-foot" style="height: 233px;">
        <img style="height: 233px;" src="../../assets/jigou/jigou-jiangxi-bottom.png">
      </div>
    </div>
    <!--江西，结束-->
    <!--广州，开始-->
    <div v-else-if="orgid=='ins_035'">
      <div class="g-foot jigou-1-foot" style="height: 106px;">
        <img style="height: 106px;" src="../../assets/jigou/jigou-guangzhou-bottom.png">
      </div>
    </div>
    <!--广州，结束-->
    <!--沈阳，开始-->
    <div v-else-if="orgid=='ins_046'">
      <div class="g-foot jigou-1-foot" style="height: 130px;">
        <img style="height: 130px;" src="../../assets/jigou/jigou-shenyang-bottom.png">
      </div>
    </div>
    <!--沈阳，结束-->
    <!--天津，开始-->
    <div v-else-if="orgid=='ins_003'">
      <div class="g-foot jigou-1-foot" style="height: 97px;">
        <img style="height: 97px;" src="../../assets/jigou/jigou-tianjin-bottom.png">
      </div>
    </div>
    <!--天津，结束-->

  </div>
</template>

<script>
  import global from '../../components/public/Common.vue';

  export default {
    name: '', // Do not use built-in or reserved HTML elements as component id
    data() {
      return {
        orgid: global.orgid
      }
    }
  }
</script>
<style scoped>
  @import "../../style/common.css";
</style>
<style lang="stylus">

</style>



// WEBPACK FOOTER //
// src/components/public/Foot.vue